import { get } from 'lodash-es'
import { emailValidate } from '@/utils/validate'
import { i18n } from '@/i18n'

const REGEXP_PWD = /^(?=.*?[A-z])(?=.*?\d)(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{6,12}$/

export const getDefaultErrorText = () => i18n.t('account.doneError')

export function validatorPwd(rule, value, callback) {
  if (typeof value === 'string' && REGEXP_PWD.test(value)) {
    return callback()
  } else {
    return callback(new Error(i18n.t('account.passwordValidPlaceholder')))
  }
}

export function createValidatorPwdAgain(ctx, path) {
  return (rule, value, callback) => {
    const pwd = get(ctx, path)

    if (typeof value === 'string' && value === pwd) {
      return callback()
    } else {
      return callback(new Error(i18n.t('account.passwordAgainValidPlaceholder')))
    }
  }
}

export function validatorEmail(rule, value, callback) {
  if (emailValidate(value)) {
    return callback()
  } else {
    return callback(new Error(i18n.t('account.emailValidPlaceholder')))
  }
}

export const getErrorCode = () => {
  return {
  // 登录
    40001: i18n.t('account.wrongPassword'),
    40002: i18n.t('account.inactive'),
    40003: i18n.t('account.overclock'),

    // 激活回调
    40101: i18n.t('account.registerEmailUsed'),
    40102: i18n.t('account.pastDue'),
    40103: i18n.t('account.invalidEmail'),

    // 重置发送邮件
    40201: i18n.t('account.emailNotRegistered'),
    40202: i18n.t('account.sendEmailError'),
    40203: i18n.t('account.overclock'),

    // 注册
    40301: i18n.t('account.registerEmailUsed'),
    40302: i18n.t('account.emailError'),
    40303: i18n.t('account.sendEmailError'),
    40304: i18n.t('account.nicknameValidPlaceholder'),
    40305: i18n.t('account.passwordValidPlaceholder'),
    40306: i18n.t('account.overclock'),

    // 重置密码
    40401: i18n.t('account.passwordValidPlaceholder'),
    40402: i18n.t('account.pastDue'),
    40403: i18n.t('account.invalidEmail'),

    // 手机验证码
    40501: i18n.t('account.verifyCodeError'),
    40502: i18n.t('account.phoneNumRegisterFailed'),
    40503: i18n.t('account.sendCodeFailed'),
    40504: i18n.t('account.shotPicVerifyCode'),
    40505: i18n.t('account.phoneBound')
  }
}
